import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { add_To_Recent_History, setPage, toggleAuthModal, toggleCreateGroupModal, toggleSideNav } from '../actions/navActions';

// Components
import Layout from '../components/layout/Layout';
import GroupsSection from '../components/Groups/GroupsSection';

// Icons
import AddIcon from '@material-ui/icons/Add';
import AllNewGroupsSection from '../components/Groups/AllNewGroupsSection';
import FollowingGroupsSection from '../components/Groups/FollowingGroupsSection';
import MyGroupsSection from '../components/Groups/MyGroupsSection';

const GroupsPage = ({
    nav: {
        sideNav,
        website,
        website_loading
    },
    auth,
    toggleSideNav,
    toggleCreateGroupModal,
    toggleAuthModal,
    setPage,
    add_To_Recent_History
}) => {
    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check if website is custom url or main website
    const [checked_WebsiteType, setChecked_WebsiteType] = useState(false);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // Posts
    const [groups, setFeedGroups] = useState([]);
    const [gotGroups, setGotGroups] = useState(false);

    // Inifite scroll
    const [lastPageDoc, setLastPageDoc] = useState(null);
    const [noMoreGroups, setNoMoreGroups] = useState(false);
    const [showBottomSpinner, setShowBottomSpinner] = useState(false)

    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;
    const notFullScreen = windowWidth <= 1170;

    // URL and filter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;

    // Listen for window resize event and update window width state
    useEffect(() => {

        setPage('groups');
        add_To_Recent_History(url.pathname);  // current url

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight} = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");

                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {

                // scrolling up - show top nav
                setScrollDirection("up");

                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more groups are met
        if (newScrollY >= scrollHeight - 1 && !showBottomSpinner && !noMoreGroups && gotGroups) {
            console.log('scrolling');
            // loadMore();
        }
    }

    const handleCreateGroup = () => {
        if(auth.loading) return;
        
        if(auth.user) {
            toggleCreateGroupModal();
        } else {
            toggleAuthModal('create group');
        }
    }

    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Groups Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    // Check if website is custom url or main website (this page is only for custom URLs)
    if(website && !checked_WebsiteType) {
        window.location.href = '/home';

        setChecked_WebsiteType(true);
    }

    return (
        <Layout handleScroll={handleScroll} sideNav={sideNav} handleSlideMenu={toggleSideNav} page="groups">
            {/* <div style={{height: 'fit-content', width: '100%', marginTop: '15px', display: 'flex', boxSizing: 'border-box', overflowX: 'scroll', overflowY: 'auto', paddingBottom: '12px', borderBottom: '1px solid #e6ecf0', background: '#fff'}}>
                <a href="/discover/tickets" 
                    style={{
                        display: 'inline-block',
                        padding: '8px 16px',
                        margin: 'auto 5px',
                        borderRadius: '9999px',
                        backgroundColor: '#E2E5E9',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '500',
                        textDecoration: 'none',
                        transition: 'background-color 0.15s ease-in-out',
                    }}>
                    Tickets
                </a>
                <a href="/discover/textbooks" 
                    style={{
                        display: 'inline-block',
                        padding: '8px 16px',
                        margin: 'auto 5px',
                        borderRadius: '9999px',
                        backgroundColor: '#E2E5E9',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '500',
                        textDecoration: 'none',
                        transition: 'background-color 0.15s ease-in-out',
                    }}>
                    Textbooks
                </a>
                <a href="/discover/clothes" 
                    style={{
                        display: 'inline-block',
                        padding: '8px 16px',
                        margin: 'auto 5px',
                        borderRadius: '9999px',
                        backgroundColor: '#E2E5E9',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '500',
                        textDecoration: 'none',
                        transition: 'background-color 0.15s ease-in-out',
                    }}>
                    Clothes
                </a>
                <a href="/discover/computers" 
                    style={{
                        display: 'inline-block',
                        padding: '8px 16px',
                        margin: 'auto 5px',
                        borderRadius: '9999px',
                        backgroundColor: '#E2E5E9',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '500',
                        textDecoration: 'none',
                        transition: 'background-color 0.15s ease-in-out',
                    }}>
                    Computers
                </a>
            </div> */}

            <div style={{width: '100%', padding: '16px', boxSizing: 'border-box'}}>
                <div onClick={(handleCreateGroup)} className='see_more_btn full_width blue'>
                    <AddIcon />
                    <div style={{width: '5px'}}></div>
                    Create a new group
                </div>
            </div>
            
            {auth.user && (
                <Fragment>
                    <MyGroupsSection />
                    <FollowingGroupsSection />
                </Fragment>
            )}
            <AllNewGroupsSection />
            <GroupsSection search_tag="colleges" />
            {/* <GroupsSection search_tag="tickets" /> */}

            <div className="no-rides" />
        </Layout>
    )
}

GroupsPage.propTypes = {
    toggleSideNav: PropTypes.func.isRequired,
    toggleCreateGroupModal: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    nav: state.nav,
    auth: state.auth,
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    toggleSideNav, 
    toggleCreateGroupModal,
    toggleAuthModal,
    setPage, 
    add_To_Recent_History,
})(GroupsPage);